import { ProcessFileType } from '../../convert/enums/process-file-type.enum';
import { DescribeProperty } from '../../common';
import { Model3dEntryStatus, Model3dEntryStatusCsv } from '../enums/model3d-entry-status.enum';
import { Model3dOutputResponse } from './model3d-output.response';

export class Model3dEntryResponse {
  @DescribeProperty({ description: 'The ID of model3d entry', type: 'string', format: 'uuid' })
  id: string;

  @DescribeProperty({ description: 'The ID of project entry', type: 'string', format: 'uuid' })
  projectEntryId: string;

  @DescribeProperty({
    description: 'List of the model3d inputs',
    type: [Model3dOutputResponse],
  })
  model3dOutputs?: Model3dOutputResponse[];

  @DescribeProperty({ description: 'File URL', type: 'string', format: 'url' })
  inputFileUrl: string;

  @DescribeProperty({ description: 'File name', type: 'string' })
  inputFileName: string | null;

  @DescribeProperty({ description: 'File type', type: 'string', enum: ProcessFileType })
  inputFileType: ProcessFileType;

  @DescribeProperty({ description: 'File size', type: 'number' })
  inputFileSize: number | null;

  @DescribeProperty({
    description: 'The flag to allow loading the model',
    type: 'boolean',
  })
  canLoad: boolean;

  @DescribeProperty({
    description: 'True if the model is converted locally',
    type: 'boolean',
  })
  localConversion: boolean;

  @DescribeProperty({
    description: 'Model X position in the scene',
    type: 'number',
  })
  userPositionX: number | null;

  @DescribeProperty({
    description: 'Model Y position in the scene',
    type: 'number',
  })
  userPositionY: number | null;

  @DescribeProperty({
    description: 'Model Z position in the scene',
    type: 'number',
  })
  userPositionZ: number | null;

  @DescribeProperty({
    description: 'Model X rotation in the scene',
    type: 'number',
  })
  userRotationX: number | null;

  @DescribeProperty({
    description: 'Model Y rotation in the scene',
    type: 'number',
  })
  userRotationY: number | null;

  @DescribeProperty({
    description: 'Model Z rotation in the scene',
    type: 'number',
  })
  userRotationZ: number | null;

  @DescribeProperty({
    description: 'Model X scale in the scene',
    type: 'number',
  })
  userScaleX: number | null;

  @DescribeProperty({
    description: 'Model Y scale in the scene',
    type: 'number',
  })
  userScaleY: number | null;

  @DescribeProperty({
    description: 'Model Z scale in the scene',
    type: 'number',
  })
  userScaleZ: number | null;

  @DescribeProperty({
    description: 'The status of model3d entry',
    type: 'string',
    enum: Model3dEntryStatus,
  })
  status: Model3dEntryStatus;

  @DescribeProperty({
    description: 'The status of model3d entry CSV generation',
    type: 'string',
    enum: Model3dEntryStatusCsv,
  })
  statusCsv: Model3dEntryStatusCsv | null;

  @DescribeProperty({ description: 'The progress status message of entry', type: 'string' })
  statusProgressMessage: string | null;

  @DescribeProperty({ description: 'The progress stage percent', type: 'decimal' })
  statusProgressPercent: number | null;

  @DescribeProperty({ description: 'The progress stage number', type: 'integer' })
  statusProgressStage: number | null;

  @DescribeProperty({ description: 'The progress total stages number', type: 'integer' })
  statusProgressTotalStages: number | null;

  @DescribeProperty({ description: 'Updated at', type: 'string', format: 'date-time' })
  updatedAt: Date;

  @DescribeProperty({ description: 'Created at', type: 'string', format: 'date-time' })
  createdAt: Date;
}
